module.exports = __webpack_public_path__ + "97de0d619db6021cfec4d6be0d84d07b.fbx";